export enum CMRole {
  ROLE_ADMIN = 'System Administrator',
  ROLE_NETWORK_ADMIN = 'Network Administrator',
  ROLE_MEDIA_SCHEDULER = 'Media Scheduler',
  ROLE_DATA_SCHEDULER = 'Data Scheduler',
  ROLE_CONTENT_CONTRIBUTOR = 'Content Contributor',
  ROLE_HOTLINE = 'Hotline',
  ROLE_LOCAL_MANAGER = 'Local Manager',
}
